import { ID, TaskListTreeItem } from '@griply/types';
import cloneDeep from 'lodash/cloneDeep';

export const filterEmptyChildrenCascading = (
  data: Record<ID, TaskListTreeItem>,
): Record<ID, TaskListTreeItem> => {
  const tempRecord = cloneDeep(data);
  const itemsToRemove = new Set<ID>();

  const parentMap = new Map<ID, Set<ID>>();
  const leafQueue: ID[] = [];

  Object.values(tempRecord).forEach((item) => {
    if (item.children && !item.children.length) {
      leafQueue.push(item.id);
      itemsToRemove.add(item.id);
    }

    if (item.children) {
      item.children.forEach((childId) => {
        if (!parentMap.has(childId)) {
          parentMap.set(childId, new Set());
        }
        parentMap.get(childId)!.add(item.id);
      });
    }
  });

  // for...of on the array iterator picks up pushes during iteration; avoids O(N) shift().
  for (const idToRemove of leafQueue) {
    const parentIds = parentMap.get(idToRemove);

    if (!parentIds) {
      continue;
    }

    parentIds.forEach((parentId) => {
      if (itemsToRemove.has(parentId)) {
        return;
      }

      const parent = tempRecord[parentId];

      if (!parent.children) {
        return;
      }

      parent.children = parent.children.filter((c) => c !== idToRemove);

      if (!parent.children.length) {
        leafQueue.push(parentId);
        itemsToRemove.add(parentId);
      }
    });
  }

  itemsToRemove.forEach((id) => {
    delete tempRecord[id];
  });

  return tempRecord;
};
